export function Greeting({ me, subtitle }) {
  const first = (me.user.name || "there").split(" ")[0];
  const now = new Date();
  const h = now.getHours();
  const hello = h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
  const today = now.toLocaleDateString("en-US", {
    weekday: "long", month: "long", day: "numeric", year: "numeric",
  });
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 flex-wrap">
        <h1 className="font-zilla text-3xl sm:text-4xl font-semibold">{hello}, {first}</h1>
      </div>
      <p className="text-[17px] text-ink/70 mt-1">{today} · {subtitle}</p>
    </div>
  );
}

export function StatCard({ label, value, note, color, onClick, ...rest }) {
  const clickable = typeof onClick === "function";
  const Cmp = clickable ? "button" : "div";
  return (
    <Cmp
      onClick={onClick}
      className={`bg-cream rounded-xl px-5 py-4 border border-ink/15 text-left w-full transition-shadow ${clickable ? "cursor-pointer hover:shadow-md hover:border-ink/30" : ""}`}
      style={{ borderTopWidth: 5, borderTopColor: color }}
      data-testid={rest["data-testid"] || "stat-card"}
    >
      <div className="text-[13px] font-bold uppercase tracking-wide text-ink/60">{label}</div>
      <div className="font-zilla text-4xl font-semibold leading-none my-1.5">{value}</div>
      <div className="text-[15px] text-ink/70">{note}</div>
    </Cmp>
  );
}

export function Panel({ title, children, action }) {
  return (
    <div className="bg-cream border border-ink/15 rounded-xl overflow-hidden">
      <div className="px-5 py-4 border-b border-ink/12 flex items-center justify-between">
        <h2 className="font-zilla text-xl font-semibold">{title}</h2>
        {action}
      </div>
      <div>{children}</div>
    </div>
  );
}

export function EmptyRow({ children }) {
  return <div className="px-5 py-8 text-center text-ink/55 text-[15px]">{children}</div>;
}

// The full list of sections (modules) the signed-in user can reach — shown on
// every role dashboard so admins get their module tiles alongside role-specific ones.
export function SectionsPanel({ me, onNavigate, title = "All your sections" }) {
  const sections = (me.nav || []).filter((n) => n.id !== "dashboard");
  if (sections.length === 0) return null;
  return (
    <Panel title={title}>
      <div className="p-2" data-testid="dash-all-sections">
        {sections.map((s) => (
          <button key={s.id} data-testid={`dash-section-${s.id}`} onClick={() => onNavigate && onNavigate(s.id)}
            className="w-full text-left px-4 py-3 border-b border-ink/8 last:border-0 flex items-center justify-between hover:bg-warm-cream/60">
            <span className="text-[15px] font-medium">{s.label}</span>
            <span className="text-[13px] uppercase tracking-wide text-ink/50 font-semibold">{s.level}</span>
          </button>
        ))}
      </div>
    </Panel>
  );
}
